module.exports = __webpack_public_path__ + "images/add-image.8b7915cbeb9f2bed3e4a3efa229c5d2f.svg";